/** 模板類型 */
export enum TemplateType {
  /** 首頁模板 */
  index,
  /** 主題模板 */
  subject
}
